<div class="container mt-3">
  <div class="d-lg-flex justify-content-end">
    <div class="d-flex justify-content-end gap-3">
      <div class="form-floating" *ngIf="data">
        <p-dropdown class="py-2" id="data" [filter]="true" filterBy="name" styleClass="w-100" [optionLabel]="(lang.isAr | async) ? 'name' : 'nameEN'"
          optionValue="id" [options]="data" [placeholder]="'validation.select_client' | translate"
          (onChange)="display($event)"></p-dropdown>
      </div>
      <!-- <div class="form-floating" *ngIf="sites">
          <p-dropdown
            [filter]="true"
            filterBy="name"
            styleClass="w-100"
            [optionLabel]="(lang.isAr | async) ? 'name' : 'nameEN'"
            optionValue="id"
            [options]="sites"
            [placeholder]="'validation.select_site' | translate"
            (onChange)="display2($event)"
          ></p-dropdown>
        </div>
        <div class="form-floating" *ngIf="branches">
          <p-dropdown
            class="py-2"
            id="branches"
            [filter]="true"
            filterBy="name"
            styleClass="w-100"
            [optionLabel]="(lang.isAr | async) ? 'name' : 'nameEN'"
            [options]="branches"
            [placeholder]="'validation.select_branch' | translate"
            (onChange)="getByBranchId($event)"
          ></p-dropdown>
        </div> -->
      <div class="dropdown menue2">
        <button class="btn myPadding rounded-m rounded-8 btn-primary d-flex gap-2 align-items-center dropdown-toggle"
          type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fa-solid fa-sliders"></i>
          {{ "filtration" | translate }}
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
          <li class="dropdown-item cursor-pointer text-align-center" (click)="getDataFilter('client')">
            {{ "client" | translate }}
          </li>
          <!-- <li
              class="dropdown-item cursor-pointer text-align-center"
              (click)="getDataFilter('site')"
            >
              {{ "site" | translate }}
            </li>
            <li
              *ngIf="isMainBranch"
              class="dropdown-item cursor-pointer text-align-center"
              (click)="getDataFilter('branch')"
            >
              {{ "security_dashboard.dash.branches" | translate }}
            </li> -->
        </ul>
      </div>
      <div>
        <button (click)="deleteFilter()" class="btn myPadding rounded-m rounded-8 btn btn-secondary d-flex gap-2"
          type="button">
          {{ "filtrationDelete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="container py-4">
  <!-- <div class="my-3">
      <div class="container card border-0 rounded-10">
        <div class="card-body">
          <div class="container d-flex justify-content-between">
            <h5 class="mt-3 mb-4">
              {{ "security_dashboard.dash.RecordedHour" | translate }}
            </h5>
            <div class="form-floating">
              <input type="email" class="form-control bg-info-o" id="input1" placeholder="date" bsDaterangepicker
                [maxDate]="maxDate" [formControl]="filterDate" [bsConfig]="{
                  containerClass: 'theme-red',
                  isAnimated: true,
                  showWeekNumbers: false,
                  adaptivePosition: true
                }" />
              <label for="input1" translate="date_range"></label>
            </div>
          </div>
          <app-my-chart></app-my-chart>
        </div>
      </div>
    </div> -->
  <!-- <div class="container">
      <div class="row">
        <div class="container-fluid  card border-0 rounded-10" *ngIf="statistic">
          <div class="card-body">
            <div class="row mt-3">
              <div class="col-lg col-md-6 my-1 pt-2 myboarder myboarder1">
                <h5 translate="security_dashboard.dash.totalHours"></h5>
                <p class>
                  {{ totalHoure }}
                </p>
              </div>
              <div class="col-lg col-md-6 my-1 pt-2 myboarder myboarder2">
                <h5 translate="security_dashboard.dash.workHours"></h5>
                <p class>{{ totalWorkHoure }}</p>
              </div>
              <div class="col-lg col-md-6 my-1 pt-2 myboarder myboarder3">
                <h5 translate="security_dashboard.dash.breakHours"></h5>
                <p class>{{ totalBrackHoure }}</p>
              </div>
              <div class="col-lg col-md-6 my-1 pt-2 myboarder myboarder4">
                <h5 translate="security_dashboard.dash.overTimeHours"></h5>
                <p class>{{ totalExstraTime }}</p>
              </div>
            </div>
          </div>
        </div>
  
      </div>
    </div> -->
</div>
<!----*ngIf="hide" depends on the package the user choose-->
<div class="container py-4">
  <div class="card h-100 border-0 rounded-10">
    <div class="card-body">
      <h5 class="fw-600 mt-2 mb-4" translate="reports.location_tracking"></h5>
      <div style="height: 450px" class>
        <google-map [options]="{ styles: style }" [center]="mainLocation" [zoom]="2">
          <map-marker-clusterer
            imagePath="https://raw.githubusercontent.com/googlearchive/js-marker-clusterer/gh-pages/images/m">
            <map-marker *ngFor="let marker of markers" [position]="{ lat: +marker.lat, lng: +marker.lng }"
              #markerElem="mapMarker" [label]="{
                  text: marker.name,
                  className: 'marker'
                }">
            </map-marker>
            <!-- <map-info-window [innerHTML]="infoContent"></map-info-window> -->
          </map-marker-clusterer>
        </google-map>
      </div>
    </div>
  </div>

  <div class="card mt-4 rounded-10 border-0">
    <div class="card-body">
      <!-- Nav tabs -->
      <div class="d-flex justify-content-between">
        <ul class="nav nav-tabs rounded-0 shadow-none" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active checkIn" id="checkIn-tab" data-bs-toggle="tab" data-bs-target="#checkIn"
              type="button" role="tab" aria-controls="checkIn" aria-selected="true">
              {{ "reports.checked_in" | translate }}
              <span class="badge bg-success">{{ checkedIn.length }}</span>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link checkOut" id="checkout-tab" data-bs-toggle="tab" data-bs-target="#checkout"
              type="button" role="tab" aria-controls="checkout" aria-selected="false">
              {{ "reports.checked_out" | translate }}
              <span class="badge bg-success">{{ checkedOut.length }}</span>
            </button>
          </li>
          <!-- <li class="nav-item" role="presentation">
              <button
                class="nav-link break"
                id="break-tab"
                data-bs-toggle="tab"
                data-bs-target="#break"
                type="button"
                role="tab"
                aria-controls="break"
                aria-selected="false"
              >
                {{ "reports.on_break" | translate }}
                <span class="badge bg-success">{{ break.length }}</span>
              </button>
            </li> -->
        </ul>
      </div>
      <!-- Tab panes -->
      <div class="tab-content">
        <div class="tab-pane active" id="checkIn" role="tabpanel" aria-labelledby="checkIn-tab">
          <div class="py-3">
            <div class="">
              <div class="row my-3">
                <div class="col-6">
                  <div class="input-group p-0">
                    <span class="input-group-text border-0 bg-transparent" id="search">
                      <ion-icon name="search"></ion-icon>
                    </span>
                    <input type="text" class="form-control" [placeholder]="'search' | translate" aria-label="search"
                      aria-describedby="search" [(ngModel)]="searchKey" />
                    <button class="btn btn-success search text-white px-3 float-end" (click)="search('checkIn')" translate="search">
                    </button>
                  </div>
                </div>
              </div>
              <div class="row row-cols-xl-3 row-cols-md-2 row-cols-1 g-4">
                <app-dash-super-card *ngFor="let item of checkedIn" (click)="details(item)" class="cursor-pointer"
                  [data]="item" [startTime]="item?.startDateTime">
                </app-dash-super-card>
              </div>
            </div>
            <div *ngIf="!checkedIn.length" class="mt-4 p-3 rounded-10 bg-info-o text-align-center fw-500"
              translate="no_data_to_show"></div>
          </div>
        </div>
        <div class="tab-pane" id="checkout" role="tabpanel" aria-labelledby="checkout-tab">
          <div class="py-3">
            <div class="">
              <div class="row my-3">
                <div class="col-6">
                  <div class="input-group p-0">
                    <span class="input-group-text border-0 bg-transparent" id="search">
                      <ion-icon name="search"></ion-icon>
                    </span>
                    <input type="text" class="form-control" [placeholder]="'search' | translate" aria-label="search"
                      aria-describedby="search" [(ngModel)]="searchKey" />
                    <button class="btn btn-success search text-white px-3 float-end" (click)="search('checkOut')" translate="search">
                    </button>
                  </div>
                </div>
              </div>
              <div class="row row-cols-xl-3 row-cols-md-2 row-cols-1 g-4">
                <app-dash-super-card *ngFor="let item of checkedOut" (click)="details(item)" class="cursor-pointer"
                  [data]="item" [startTime]="item.startTime"
                  [endTime]="item.leaveTime" >
                </app-dash-super-card>
              </div>
            </div>
            <div *ngIf="!checkedOut.length" class="mt-4 p-3 rounded-10 bg-info-o text-align-center fw-500"
              translate="no_data_to_show"></div>
          </div>
        </div>
        <!-- <div class="tab-pane" id="break" role="tabpanel" aria-labelledby="break-tab">
          <div class="py-3">
            <div class="">
              <div class="row my-3">
                <div class="col-6">
                  <div class="input-group">
                    <span class="input-group-text border-0 bg-transparent" id="search">
                      <ion-icon name="search"></ion-icon>
                    </span>
                    <input type="text" class="form-control" [placeholder]="'search' | translate" aria-label="search"
                      aria-describedby="search" [(ngModel)]="searchKey" (blur)="search('checkBreak')" />
                  </div>
                </div>
              </div>
              <div class="row row-cols-xl-3 row-cols-md-2 row-cols-1 g-4">
                <app-dash-guard-card *ngFor="let item of break" (click)="details(item)" class="cursor-pointer"
                  [data]="item" [startTime]="item.startTime" [endTime]="item.leaveTime"
                  [breakTime]="item.toTalBreakTime">
                </app-dash-guard-card>
              </div>
            </div>
            <div *ngIf="!break.length" class="mt-4 p-3 rounded-10 bg-info-o text-align-center fw-500"
              translate="no_data_to_show"></div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>